import { render } from "./AddressBookTable.vue?vue&type=template&id=4c6c1c3c&scoped=true"
import script from "./AddressBookTable.vue?vue&type=script&lang=js"
export * from "./AddressBookTable.vue?vue&type=script&lang=js"

import "./AddressBookTable.vue?vue&type=style&index=0&id=4c6c1c3c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6c1c3c"]])

export default __exports__